<template>
  <div v-if="serviceOrder" class="container">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <div class="header">
      <Message
        severity="error"
        :closable="false"
        icon="pi-exclamation-triangle"
        v-if="!serviceOrder.pat_id"
      >
        <span class="p-d-flex p-ai-center p-jc-between">
          <span>Pat da Ordem de Serviço não está Criado</span>
          <Button
            label="Criar"
            icon="pi pi-check-circle"
            class="p-button-sm p-button-info"
            @click="createPat"
            v-if="can('createPatFromDgServiceOrder')"
          />
        </span>
      </Message>
    </div>
    <div class="content">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="referral" type="text" v-model="serviceOrder.referral" :disabled="true" />
            <label for="referral">Referral</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="policy_number" type="text" v-model="serviceOrder.policy_number" :disabled="true" />
            <label for="policy_number">Nº Apólice</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="pat_id" type="text" v-model="serviceOrder.pat_id" :disabled="true" />
            <label for="pat_id">PAT</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <Textarea id="problem" :autoResize="true" v-model="serviceOrder.problem" :disabled="true" />
            <label for="problem">Problema</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="failure_type_code" type="text" v-model="serviceOrder.failure_type_code" :disabled="true" />
            <label for="failure_type_code">Tipo de Avaria</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="claim_status_code" type="text" v-model="serviceOrder.claim_status_code" :disabled="true" />
            <label for="claim_status_code">Situação Claim</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="start_date" type="text" v-model="serviceOrder.start_date" :disabled="true" />
            <label for="start_date">Data Início</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="last_modified_date" type="text" v-model="serviceOrder.last_modified_date" :disabled="true" />
            <label for="last_modified_date">Última Modificação</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="brand_code" type="text" v-model="serviceOrder.product.brand_code" :disabled="true" />
            <label for="brand_code">Marca</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="model" type="text" v-model="serviceOrder.product.model" :disabled="true" />
            <label for="model">Modelo</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="serial_number" type="text" v-model="serviceOrder.product.serial_number" :disabled="true" />
            <label for="serial_number">Nº Série</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="purchase_date" type="text" v-model="serviceOrder.product.purchase_date" :disabled="true" />
            <label for="purchase_date">Data da Compra</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="customer_first_name" type="text" v-model="serviceOrder.customer.first_name" :disabled="true" />
            <label for="customer_first_name">Cliente Nome</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="customer_last_name" type="text" v-model="serviceOrder.customer.last_name" :disabled="true" />
            <label for="customer_last_name">Cliente Apelido</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="customer_telephone" type="text" v-model="serviceOrder.customer.telephone" :disabled="true" />
            <label for="customer_telephone">Cliente Telefone</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="customer_mobile_phone" type="text" v-model="serviceOrder.customer.mobile_phone" :disabled="true" />
            <label for="customer_mobile_phone">Cliente Telemóvel</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="customer_email" type="text" v-model="serviceOrder.customer.email" :disabled="true" />
            <label for="customer_email">Cliente Email</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="delivery_address" type="text" v-model="serviceOrder.delivery.address" :disabled="true" />
            <label for="delivery_address">Morada</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="delivery_zip_code" type="text" v-model="serviceOrder.delivery.zip_code" :disabled="true" />
            <label for="delivery_zip_code">Código Postal</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText id="delivery_city" type="text" v-model="serviceOrder.delivery.city" :disabled="true" />
            <label for="delivery_city">Localidade</label>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import serviceOrdersService from "../../services/serviceOrders.service";
export default {
  name: "DetailDg",
  props: ["serviceOrder"],
  methods: {
    createPat() {
      return serviceOrdersService
        .serviceOrderDgCreatePat(this.serviceOrder.id)
        .then((response) => {
          if (!response || response.error !== undefined) {
            return this.$toast.add({
              severity: "error",
              summary: `Ocorreu um erro`,
              detail: response ? response.error : "Resposta inválida",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Ordem Serviço Atualizada`,
            detail: "",
            life: 3000,
          });
          return this.$emit("createPatOk", response);
        });
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  overflow: auto;
  padding: 10px;
}
</style>
<style lang="css" scoped>
:deep(.p-message-text) {
  width: 100% !important;
}
</style>
